import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";

const analysisStructureApi = tokenSlice.injectEndpoints({
  reducerPath: 'analysisStructure',
  baseQuery: createBaseQuery(),
  tagTypes: ['AnalysisStructure'],
  endpoints(builder) {
    return {

      // GET

      getAnalysisStructure: builder.query({
        query: (args) => {
          const { businessUnitId, procedureId } = args;
          return {
            url: `AnalysisStructure?businessUnitId=${businessUnitId}&procedureId=${procedureId}`,
          }
        },
        providesTags: ['AnalysisStructure']
      }),

      // POST

      postAnalysisStructureSave: builder.mutation({
        query: (data) => ({
          url: 'AnalysisStructure',
          method: 'POST',
          body: data
        }),
        invalidatesTags: ['AnalysisStructure'],
      }),

      // DELETE

      deleteAnalysisStructureDelete: builder.mutation({
        query: (data) => ({
          url: 'AnalysisStructure',
          method: 'DELETE',
          body: data
        }),
        invalidatesTags: ['AnalysisStructure']
      }),
    }
  }
})

export const {
  useGetAnalysisStructureQuery, usePostAnalysisStructureSaveMutation, useDeleteAnalysisStructureDeleteMutation } = analysisStructureApi;
export { analysisStructureApi };